import useValidations from '../../../validations';

/*
    Hook that processes a validation request on a html element or form.
*/
const useValidate = () => {
  const { validate } = useValidations();

  /* 
      Executes all validations on a page for a particular form
   */
  const validateForm = async ({ page, data, step }) => {
    return await validate({ page, data, formId: step.validateFormId });
  };

  const validateElement = async ({ step, data, page }) => {
    return await validate({
      page,
      data,
      formId: step.validateFormId,
      htmlElement: { id: step.validateFormElementId }
    });
  };

  return {
    validateForm,
    validateElement
  };
};

export default useValidate;
